// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__gAlXI","imgContainer":"NotFound_imgContainer__e2SGT","img":"NotFound_img__aGlnA","notfound":"NotFound_notfound__a94+w"};